// ─── Mixordia i18n — PT/EN translations ────────────────────────────────────
// Structure: { pt: { key: value }, en: { key: value } }
// Supports simple interpolation: "Hello {{name}}" → t("key", { name: "World" })
// ────────────────────────────────────────────────────────────────────────────

const translations = {
  pt: {
    // ── TV Boot Intro ───────────────────────────────────────────
    "intro.ariaLabel": "Ligar a TV e entrar no site",

    // ── TV Buttons ──────────────────────────────────────────────
    "tv.subscribe": "Inscreva-se",
    "tv.gallery": "Eventos",
    "tv.partners": "Destaques",

    // ── Destaques ───────────────────────────────────────────────
    "destaques.brandLabel": "destaques",
    "destaques.modeGroupAria": "Modo de visualização",
    "destaques.modeTune": "sintonizar",
    "destaques.modeGrid": "grade",
    "destaques.closeAria": "Fechar",
    "destaques.tuning": "sintonizando…",
    "destaques.noSignal": "sem sinal",
    "destaques.errorSub": "a transmissão caiu",
    "destaques.retryButton": "sintonizar de novo",
    "destaques.standbySub": "escolha um canal abaixo",
    "destaques.arrowPrevAria": "{{rotulo}}: anterior",
    "destaques.arrowNextAria": "{{rotulo}}: próximo",
    "destaques.tvHint": "↑ ↓ troca de canal · esc fecha",
    "destaques.tagline": "a pista acaba. a transmissão não.",
    "destaques.acervoLabel": "no acervo",
    "destaques.acervoCount_one": "{{count}} gravação",
    "destaques.acervoCount_other": "{{count}} gravações",
    "destaques.proximoRitualLabel": "próximo ritual",
    "destaques.rituaisTitle": "próximos rituais",
    "destaques.badgeProximo": "próximo",
    "destaques.dayToday": "é hoje",
    "destaques.dayTomorrow": "amanhã",
    "destaques.inDays": "em {{dias}} dias",
    "destaques.inMonths_one": "em cerca de 1 mês",
    "destaques.inMonths_other": "em cerca de {{count}} meses",
    "destaques.ticketsSoon": "em breve",
    "destaques.ticketsCta": "ingressos",
    "destaques.gravacoesTitle": "gravações",
    "destaques.sourceVideo": "vídeo",
    "destaques.sourceAudio": "áudio",
    "destaques.seeMore": "ver mais",
    "destaques.seeLess": "ver menos",
    "destaques.merchTitle": "merch",
    "destaques.merchUnavailable": "em breve",
    "destaques.merchOrder": "pedir",
    "destaques.gradeSlotLabel": "set",
    "destaques.gradeClose": "fechar",
    "destaques.gradeListen": "ouvir",
    "destaques.gradeWatch": "assistir",
    "destaques.partnersHeading": "quem faz junto",
    "destaques.closingLine": "fim da transmissão",
    "destaques.closingTitle": "não perca o próximo sinal.",
    "destaques.closingCta": "faça parte",

    // ── Event Gallery ───────────────────────────────────────────
    "gallery.title": "Eventos",
    "gallery.loading": "Carregando eventos...",
    "gallery.error": "Não foi possível carregar os eventos.",
    "gallery.empty": "Nenhum evento encontrado.",
    "gallery.photoCount_one": "{{count}} foto",
    "gallery.photoCount_other": "{{count}} fotos",
    "gallery.flyer": "Flyer",

    // ── Photo Gallery ───────────────────────────────────────────
    "photos.loading": "Carregando fotos...",
    "photos.error": "Não foi possível carregar as fotos.",
    "photos.emptyNamed": 'Nenhuma foto encontrada para "{{name}}".',
    "photos.empty": "Nenhuma foto encontrada.",
    "photos.openAria": "Abrir foto {{index}}",
    "photos.alt": "Foto {{index}}",

    // ── Newsletter Form ─────────────────────────────────────────
    "form.title": "Cadastre-se e desbloqueie vantagens exclusivas da comunidade Mixórdia",
    "form.benefit1": "Acesso a tickets exclusivos",
    "form.benefit2": "Novidades em primeira mão",
    "form.updateHint": "Caso já tenha realizado um cadastro anteriormente, basta preencher novamente para atualizar suas informações.",
    "form.contactLabel": "Por onde você gostaria de ser comunicado?",
    "form.contactEmail": "E-Mail",
    "form.contactWhatsApp": "WhatsApp",
    "form.contactInstagram": "Instagram DM",

    "form.nameLabel": "Qual o seu nome completo?",
    "form.cityLabel": "Onde você mora?",
    "form.nationalityLabel": "Qual a sua nacionalidade?",
    "form.cpfLabel": "Informe seu número de CPF",
    "form.emailLabel": "Informe seu e-mail",
    "form.phoneLabel": "Informe seu número de celular",
    "form.instagramLabel": "Informe seu @ do Instagram",
    "form.birthPlaceholder": "dd/mm/aaaa",
    "form.phonePlaceholder": "+__ (código do país) número",
    "form.attendedEvent": "Já fui em um evento Mixordia",
    "form.attendedEventYes": "Sim",
    "form.attendedEventNo": "Não",
    "form.birthLabel": "Data de Nascimento",
    "form.consent": "Ao me inscrever, autorizo a Mixordia a armazenar meus dados para comunicação sobre eventos.",
    "form.privacyLink": "Política de Privacidade",
    "form.submitting": "ENVIANDO...",
    "form.submit": "ENVIAR",
    "form.cancel": "CANCELAR",
    "form.contactUs": "Dúvidas? Fala com a gente:",

    // ── Validation ─────────────────────────────────────────────
    "validation.nameRequired": "Preencha seu nome.",
    "validation.nationalityRequired": "Selecione sua nacionalidade.",
    "validation.contactRequired": "Selecione como quer ser informado.",
    "validation.cpfRequired": "Preencha seu CPF.",
    "validation.cpfInvalid": "CPF inválido. Verifique os números digitados.",
    "validation.emailRequired": "Preencha seu e-mail.",
    "validation.emailInvalid": "E-mail inválido. Verifique o formato (ex: nome@email.com).",
    "validation.phoneRequired": "Preencha seu número de celular.",
    "validation.phoneInvalid": "Número inválido. Inclua DDD (ex: +55 11 99999-9999).",
    "validation.instagramInvalid": "Instagram inválido. Informe seu @ (ex: @seuuser).",
    "validation.cityRequired": "Preencha sua cidade.",
    "validation.birthRequired": "Preencha sua data de nascimento.",
    "validation.birthInvalid": "Data de nascimento inválida.",
    "validation.attendedEventRequired": "Selecione se você já foi a um evento Mixordia.",
    "validation.genericError": "Ops, algo deu errado. Tente novamente.",

    // ── Success Modal ───────────────────────────────────────────
    "success.titleNew": "Agora você faz parte de algo maior.",
    "success.titleUpdate": "Seus dados foram atualizados!",
    "success.messageNew": "Fique de olho, em breve você receberá novidades sobre os próximos eventos da Mixordia.",
    "success.messageUpdate": "Suas informações foram atualizadas com sucesso. Nos vemos no próximo evento.",
    "success.close": "FECHAR",
    "success.ctaInstagram": "siga a gente no Instagram",
    "success.ctaGallery": "veja nossos últimos eventos",
    "success.ctaPartners": "veja nossos destaques",

    // ── 404 ─────────────────────────────────────────────────────
    "notfound.title": "Sinal perdido.",
    "notfound.message": "A página que você procura não existe ou foi removida.",
    "notfound.ctaSubscribe": "Inscreva-se",
    "notfound.ctaHome": "Voltar ao início",

    // ── Privacy Policy ──────────────────────────────────────────
    "privacy.title": "Política de Privacidade",
    "privacy.lastUpdate": "Última atualização: Março de 2026",
    "privacy.section1Title": "1. Quem somos",
    "privacy.section1Text": "A Mixordia é uma marca de eventos musicais. Esta política descreve como coletamos, usamos e protegemos seus dados pessoais quando você se cadastra em nossa plataforma.",
    "privacy.section2Title": "2. Dados coletados",
    "privacy.section2Intro": "Ao preencher o formulário de inscrição, coletamos:",
    "privacy.section2Required": "Obrigatórios: nome completo, e-mail, telefone, data de nascimento, cidade, forma de contato preferida e se você já foi a um evento Mixordia. Residentes no Brasil também informam o CPF (identificador único)",
    "privacy.section2Optional": "Instagram: pedimos seu @ apenas quando você escolhe Instagram DM como forma de contato preferida",
    "privacy.section3Title": "3. Finalidade",
    "privacy.section3Intro": "Seus dados são utilizados para:",
    "privacy.section3Item1": "Comunicação sobre eventos, promoções e novidades da Mixordia",
    "privacy.section3Item2": "Identificação única no check-in de eventos (CPF)",
    "privacy.section3Item3": "Melhoria da experiência nos nossos eventos (preferências)",
    "privacy.section4Title": "4. Compartilhamento",
    "privacy.section4Text": "Seus dados não serão vendidos, alugados ou compartilhados com terceiros para fins comerciais. Podemos compartilhar dados apenas com parceiros operacionais diretamente envolvidos na realização dos eventos (ex: sistema de check-in).",
    "privacy.section5Title": "5. Armazenamento e segurança",
    "privacy.section5Text": "Seus dados são armazenados em servidores seguros com criptografia em trânsito (HTTPS/TLS). O acesso é restrito apenas aos organizadores autorizados da Mixordia.",
    "privacy.section6Title": "6. Seus direitos (LGPD)",
    "privacy.section6Intro": "Conforme a Lei Geral de Proteção de Dados (Lei 13.709/2018), você tem direito a:",
    "privacy.section6Item1": "Acessar seus dados pessoais",
    "privacy.section6Item2": "Corrigir dados incompletos ou desatualizados",
    "privacy.section6Item3": "Solicitar a exclusão dos seus dados",
    "privacy.section6Item4": "Revogar o consentimento a qualquer momento",
    "privacy.section7Title": "7. Contato",
    "privacy.section7Text": "Para exercer seus direitos ou tirar dúvidas sobre seus dados, entre em contato pelo Instagram {{instagram}} ou pelo e-mail {{email}}.",
    "privacy.close": "FECHAR",
  },

  en: {
    // ── TV Boot Intro ───────────────────────────────────────────
    "intro.ariaLabel": "Turn on the TV and enter the site",

    // ── TV Buttons ──────────────────────────────────────────────
    "tv.subscribe": "Subscribe",
    "tv.gallery": "Events",
    "tv.partners": "Highlights",

    // ── Destaques ───────────────────────────────────────────────
    "destaques.brandLabel": "highlights",
    "destaques.modeGroupAria": "View mode",
    "destaques.modeTune": "tune",
    "destaques.modeGrid": "grid",
    "destaques.closeAria": "Close",
    "destaques.tuning": "tuning…",
    "destaques.noSignal": "no signal",
    "destaques.errorSub": "the signal dropped",
    "destaques.retryButton": "tune again",
    "destaques.standbySub": "choose a channel below",
    "destaques.arrowPrevAria": "{{rotulo}}: previous",
    "destaques.arrowNextAria": "{{rotulo}}: next",
    "destaques.tvHint": "↑ ↓ change channel · esc closes",
    "destaques.tagline": "the dancefloor ends. the broadcast doesn't.",
    "destaques.acervoLabel": "in the archive",
    "destaques.acervoCount_one": "{{count}} recording",
    "destaques.acervoCount_other": "{{count}} recordings",
    "destaques.proximoRitualLabel": "next ritual",
    "destaques.rituaisTitle": "upcoming rituals",
    "destaques.badgeProximo": "up next",
    "destaques.dayToday": "today",
    "destaques.dayTomorrow": "tomorrow",
    "destaques.inDays": "in {{dias}} days",
    "destaques.inMonths_one": "in about 1 month",
    "destaques.inMonths_other": "in about {{count}} months",
    "destaques.ticketsSoon": "coming soon",
    "destaques.ticketsCta": "tickets",
    "destaques.gravacoesTitle": "recordings",
    "destaques.sourceVideo": "video",
    "destaques.sourceAudio": "audio",
    "destaques.seeMore": "see more",
    "destaques.seeLess": "see less",
    "destaques.merchTitle": "merch",
    "destaques.merchUnavailable": "coming soon",
    "destaques.merchOrder": "order",
    "destaques.gradeSlotLabel": "set",
    "destaques.gradeClose": "close",
    "destaques.gradeListen": "listen",
    "destaques.gradeWatch": "watch",
    "destaques.partnersHeading": "with",
    "destaques.closingLine": "end of transmission",
    "destaques.closingTitle": "don't miss the next signal.",
    "destaques.closingCta": "join us",

    // ── Event Gallery ───────────────────────────────────────────
    "gallery.title": "Events",
    "gallery.loading": "Loading events...",
    "gallery.error": "Could not load events.",
    "gallery.empty": "No events found.",
    "gallery.photoCount_one": "{{count}} photo",
    "gallery.photoCount_other": "{{count}} photos",
    "gallery.flyer": "Flyer",

    // ── Photo Gallery ───────────────────────────────────────────
    "photos.loading": "Loading photos...",
    "photos.error": "Could not load photos.",
    "photos.emptyNamed": 'No photos found for "{{name}}".',
    "photos.empty": "No photos found.",
    "photos.openAria": "Open photo {{index}}",
    "photos.alt": "Photo {{index}}",

    // ── Newsletter Form ─────────────────────────────────────────
    "form.title": "Sign up and unlock exclusive perks from the Mixórdia community",
    "form.benefit1": "Access to exclusive tickets",
    "form.benefit2": "News first-hand",
    "form.updateHint": "If you've already signed up, just fill in the form again to update your info.",
    "form.contactLabel": "How would you like to be contacted?",
    "form.contactEmail": "E-Mail",
    "form.contactWhatsApp": "WhatsApp",
    "form.contactInstagram": "Instagram DM",

    "form.nameLabel": "What is your full name?",
    "form.cityLabel": "Where do you live?",
    "form.nationalityLabel": "What is your nationality?",
    "form.cpfLabel": "Enter your CPF number",
    "form.emailLabel": "Enter your e-mail",
    "form.phoneLabel": "Enter your mobile number",
    "form.instagramLabel": "Enter your Instagram @",
    "form.birthPlaceholder": "dd/mm/yyyy",
    "form.phonePlaceholder": "+__ (country code) number",
    "form.attendedEvent": "I've been to a Mixordia event",
    "form.attendedEventYes": "Yes",
    "form.attendedEventNo": "No",
    "form.birthLabel": "Date of Birth",
    "form.consent": "By subscribing, I authorize Mixordia to store my data for event communication purposes.",
    "form.privacyLink": "Privacy Policy",
    "form.submitting": "SENDING...",
    "form.submit": "SUBMIT",
    "form.cancel": "CANCEL",
    "form.contactUs": "Questions? Reach us at:",

    // ── Validation ─────────────────────────────────────────────
    "validation.nameRequired": "Please enter your name.",
    "validation.nationalityRequired": "Select your nationality.",
    "validation.contactRequired": "Select how you want to be contacted.",
    "validation.cpfRequired": "Please enter your CPF.",
    "validation.cpfInvalid": "Invalid CPF. Please check the numbers.",
    "validation.emailRequired": "Please enter your e-mail.",
    "validation.emailInvalid": "Invalid email. Check the format (e.g. name@email.com).",
    "validation.phoneRequired": "Please enter your mobile number.",
    "validation.phoneInvalid": "Invalid number. Include area code (e.g. +55 11 99999-9999).",
    "validation.instagramInvalid": "Invalid Instagram. Enter your @ (e.g. @youruser).",
    "validation.cityRequired": "Please enter your city.",
    "validation.birthRequired": "Please enter your date of birth.",
    "validation.birthInvalid": "Invalid date of birth.",
    "validation.attendedEventRequired": "Select whether you've been to a Mixordia event.",
    "validation.genericError": "Oops, something went wrong. Please try again.",

    // ── Success Modal ───────────────────────────────────────────
    "success.titleNew": "You're now part of something bigger.",
    "success.titleUpdate": "Your info has been updated!",
    "success.messageNew": "Stay tuned — you'll soon receive news about Mixordia's upcoming events.",
    "success.messageUpdate": "Your information has been successfully updated. See you at the next event.",
    "success.close": "CLOSE",
    "success.ctaInstagram": "follow us on Instagram",
    "success.ctaGallery": "check out our latest events",
    "success.ctaPartners": "see our highlights",

    // ── 404 ─────────────────────────────────────────────────────
    "notfound.title": "Signal lost.",
    "notfound.message": "The page you're looking for doesn't exist or has been removed.",
    "notfound.ctaSubscribe": "Subscribe",
    "notfound.ctaHome": "Back to home",

    // ── Privacy Policy ──────────────────────────────────────────
    "privacy.title": "Privacy Policy",
    "privacy.lastUpdate": "Last updated: March 2026",
    "privacy.section1Title": "1. Who we are",
    "privacy.section1Text": "Mixordia is a music events brand. This policy describes how we collect, use and protect your personal data when you register on our platform.",
    "privacy.section2Title": "2. Data collected",
    "privacy.section2Intro": "When filling out the registration form, we collect:",
    "privacy.section2Required": "Required: full name, e-mail, phone number, date of birth, city, preferred contact method, and whether you've been to a Mixordia event before. Brazilian residents also provide their CPF (used as a unique identifier)",
    "privacy.section2Optional": "Instagram: we ask for your @ only when you choose Instagram DM as your preferred contact method",
    "privacy.section3Title": "3. Purpose",
    "privacy.section3Intro": "Your data is used for:",
    "privacy.section3Item1": "Communication about Mixordia events, promotions and news",
    "privacy.section3Item2": "Unique identification at event check-in (CPF)",
    "privacy.section3Item3": "Improving the experience at our events (preferences)",
    "privacy.section4Title": "4. Sharing",
    "privacy.section4Text": "Your data will not be sold, rented or shared with third parties for commercial purposes. We may share data only with operational partners directly involved in hosting events (e.g., check-in system).",
    "privacy.section5Title": "5. Storage and security",
    "privacy.section5Text": "Your data is stored on secure servers with encryption in transit (HTTPS/TLS). Access is restricted to authorized Mixordia organizers only.",
    "privacy.section6Title": "6. Your rights (LGPD)",
    "privacy.section6Intro": "Under Brazil's General Data Protection Law (Law 13,709/2018), you have the right to:",
    "privacy.section6Item1": "Access your personal data",
    "privacy.section6Item2": "Correct incomplete or outdated data",
    "privacy.section6Item3": "Request deletion of your data",
    "privacy.section6Item4": "Revoke consent at any time",
    "privacy.section7Title": "7. Contact",
    "privacy.section7Text": "To exercise your rights or ask questions about your data, contact us via Instagram {{instagram}} or e-mail {{email}}.",
    "privacy.close": "CLOSE",
  },
};

export default translations;
